import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function AdventurersClubReopen() {
  const dateTexts = ['1989年'];
  const title = 'アドベンチャラーズクラブ 再オープン';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/AdventurersClubExterior.jpg'
  const description = (
    <>
      {'1987年、長年見捨てられていたプレジャーアイランドを考古学者チームが発見する。大規模な復興作業の末に、1989年、新プレジャーアイランドがオープンする。'}
      {'同時に'}
      <a href='/adventurers-club'>
        {'アドベンチャラーズクラブ'}
      </a>
      {'も再オープンする。'}
    </>
  );
  const quoteDomain = 'en.wikipedia.org';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default AdventurersClubReopen;
